import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui/select";
import { RATING_SCALE } from "~/services/const";

type Params = {
  initialRating: string;
  onUpdate: (value: string) => void;
};

export function RatingSelector({ initialRating, onUpdate }: Params) {
  return (
    <Select defaultValue={String(initialRating)} onValueChange={onUpdate}>
      <SelectTrigger className="w-full sm:w-[380px]">
        <SelectValue placeholder="Escolha a pontuação" />
      </SelectTrigger>
      <SelectContent>
        {RATING_SCALE.map((item) => (
          <SelectItem key={item.value} value={String(item.value)}>
            {item.label} — {item.description}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
